import { render, staticRenderFns } from "./LiabilitiesFull.vue?vue&type=template&id=4e819bcc"
import script from "./LiabilitiesFull.vue?vue&type=script&lang=js"
export * from "./LiabilitiesFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports